import { useStudioContext } from './studioContext';
import { AssetTypes } from './studioContext/CMSParams';

const useIsStory = () => {
  const { assetType } = useStudioContext();
  return assetType === AssetTypes.Story;
};

export default useIsStory;
